import Cookies from 'universal-cookie';
import type { DecriptJwtTokenType } from '@/models/users';
import services from '@/services';
import { parseJwt } from '@/utils/common';

export const useAuth = () => {
   const cookies = new Cookies();
   const jwt = cookies.get('jwt') as string | undefined;

   let token: DecriptJwtTokenType | undefined;

   try {
      token = jwt ? (parseJwt(jwt) as DecriptJwtTokenType) : undefined;
   } catch {
      token = undefined;
   }

   const userId = token?.user_id;
   const isAuthenticated = !!jwt && !!userId;

   const logout = async () => {
      const cookies = new Cookies();
      const jwt = cookies.get('jwt');

      if (jwt) {
         try {
            await services.auth.logout(jwt);
         } catch (error) {
            console.error('Logout API call failed:', error);
         }
      }

      cookies.remove('jwt', { domain: process.env.DOMAIN, path: '/' });
      window.location.href = `${process.env.PORTAIL_URL}/auth`;
   };

   return { jwt, token, userId, isAuthenticated, logout };
};
